define("settings/components/meta-ad-accounts-card/connect-banner/index", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@glimmer/component", "ember-concurrency", "later/utils/constants/segment-events", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _component2, _emberConcurrency, _segmentEvents, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"later/utils/constants/segment-events",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.shouldShow}}
    <div class="u--p__b">
      <div class="cIC--card cIC--card__info u--m__t__0 qa--mmaConnectBanner" data-test-id="mma-connect-banner">
        <div class="cIC--cardHeader">
          <p class="cIC--cardHeader__title">{{t "account.meta_marketing_api.connect_banner.title"}}</p>
        </div>
        <div class="cIC--cardBody">
          {{! cIC--cardBody drops to $FONT_SIZE_SM; the design calls for base. }}
          <p class="u--text--base">{{t "account.meta_marketing_api.connect_banner.description"}}</p>
          <Shared::Ui::Button
            @promise={{this.connect}}
            @text={{t "account.meta_marketing_api.connect_banner.connect_button"}}
            @variant="primary"
            class="qa--mmaConnectBanner__connectBtn"
          />
        </div>
      </div>
    </div>
  {{/if}}
  */
  {
    "id": "nxqwFFDX",
    "block": "[[[41,[30,0,[\"shouldShow\"]],[[[1,\"  \"],[10,0],[14,0,\"u--p__b\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"cIC--card cIC--card__info u--m__t__0 qa--mmaConnectBanner\"],[14,\"data-test-id\",\"mma-connect-banner\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"cIC--cardHeader\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"cIC--cardHeader__title\"],[12],[1,[28,[35,1],[\"account.meta_marketing_api.connect_banner.title\"],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"cIC--cardBody\"],[12],[1,\"\\n\"],[1,\"        \"],[10,2],[14,0,\"u--text--base\"],[12],[1,[28,[35,1],[\"account.meta_marketing_api.connect_banner.description\"],null]],[13],[1,\"\\n        \"],[8,[39,2],[[24,0,\"qa--mmaConnectBanner__connectBtn\"]],[[\"@promise\",\"@text\",\"@variant\"],[[30,0,[\"connect\"]],[28,[37,1],[\"account.meta_marketing_api.connect_banner.connect_button\"],null],\"primary\"]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[],false,[\"if\",\"t\",\"shared/ui/button\"]]",
    "moduleName": "settings/components/meta-ad-accounts-card/connect-banner/index.hbs",
    "isStrictMode": false
  });
  const LOCATION = 'social sets and access groups';
  let MetaAdAccountsCardConnectBannerComponent = _exports.default = (_class = class MetaAdAccountsCardConnectBannerComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "metaMarketingApiAuth", _descriptor2, this);
      _initializerDefineProperty(this, "segment", _descriptor3, this);
      _defineProperty(this, "connect", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.segment.track(_segmentEvents.SegmentEventTypes.ClickedConnectMetaBusinessAccount, {
            location: LOCATION
          });
          yield this.metaMarketingApiAuth.connect.perform();
        }
      }), null, "connect", null));
    }
    get shouldShow() {
      const account = this.auth.currentAccount;
      return Boolean(account?.canUseMetaMarketingApi && account?.canAccessCustomAnalytics && !this.auth.currentUserModel?.metaAdUser);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "metaMarketingApiAuth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MetaAdAccountsCardConnectBannerComponent);
});